<div *ngFor="let record of materials" class='request-materials'>
  <h4>{{ record.methname }}</h4>
  <afoone-request-tests-list [tests]="record.tests"></afoone-request-tests-list>
  <afoone-request-antibiotics [antibiotics]="record.antibioticos"></afoone-request-antibiotics>
</div>
